import { ClipboardModule } from "@angular/cdk/clipboard";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgAsModule } from "ng-as";
import { NgLetDirective } from "ng-let";
import { BaseChartDirective } from "ng2-charts";
import { MarkdownModule } from "ngx-markdown";
import { AccordionModule } from "primeng/accordion";
import { ConfirmationService, MessageService } from "primeng/api";
import { AutoCompleteModule } from "primeng/autocomplete";
import { ButtonModule } from "primeng/button";
import { CalendarModule } from "primeng/calendar";
import { CardModule } from "primeng/card";
import { ChartModule } from "primeng/chart";
import { CheckboxModule } from "primeng/checkbox";
import { ChipModule } from "primeng/chip";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { ConfirmPopupModule } from "primeng/confirmpopup";
import { ContextMenuModule } from "primeng/contextmenu";
import { DialogModule } from "primeng/dialog";
import { DividerModule } from "primeng/divider";
import { DragDropModule } from "primeng/dragdrop";
import { DialogService } from "primeng/dynamicdialog";
import { EditorModule } from "primeng/editor";
import { FileUploadModule } from "primeng/fileupload";
import { FloatLabelModule } from "primeng/floatlabel";
import { ImageModule } from "primeng/image";
import { InputSwitchModule } from "primeng/inputswitch";
import { InputTextModule } from "primeng/inputtext";
import { InputTextareaModule } from "primeng/inputtextarea";
import { MenuModule } from "primeng/menu";
import { MessagesModule } from "primeng/messages";
import { MultiSelectModule } from "primeng/multiselect";
import { OverlayPanelModule } from "primeng/overlaypanel";
import { PaginatorModule } from "primeng/paginator";
import { PanelModule } from "primeng/panel";
import { ProgressBarModule } from "primeng/progressbar";
import { ProgressSpinnerModule } from "primeng/progressspinner";
import { RippleModule } from "primeng/ripple";
import { ScrollPanelModule } from "primeng/scrollpanel";
import { SelectButtonModule } from "primeng/selectbutton";
import { SkeletonModule } from "primeng/skeleton";
import { SliderModule } from "primeng/slider";
import { TableModule } from "primeng/table";
import { TabViewModule } from "primeng/tabview";
import { TieredMenuModule } from "primeng/tieredmenu";
import { ToastModule } from "primeng/toast";
import { ToggleButtonModule } from "primeng/togglebutton";
import { TooltipModule } from "primeng/tooltip";
import { TreeSelectModule } from "primeng/treeselect";
import { AddContextMenuComponent } from "src/app/common/components/add-context-menu/add-context-menu.component";
import { AddFilesPopupComponent } from "src/app/common/components/add-files-popup/add-files-popup.component";
import { UserNeedsCompactComponent } from "src/app/common/components/analysis-tabs/user-needs-compact-component/user-needs-compact.component";
import { UserNeedsTabComponent } from "src/app/common/components/analysis-tabs/user-needs-tab/user-needs-tab-component/user-needs-tab.component";
import { SpeakerComponent } from "src/app/common/components/chat/speaker/speaker.component";
import { SpeechSegmentComponent } from "src/app/common/components/chat/speech-segment/speech-segment.component";
import { DropListComponent } from "src/app/common/components/drop-list/drop-list.component";
import { ExtensibleTextareaComponent } from "src/app/common/components/extensible-textarea/extensible-textarea.component";
import { FeatureTourButtonComponent } from "src/app/common/components/feature-tour-button/feature-tour-button.component";
import { FiltersComponent } from "src/app/common/components/filters/filters.component";
import { AssistantChatComponent } from "src/app/common/components/floating-assistant-chat/assistant-chat/assistant-chat.component";
import { AssistantSettingsComponent } from "src/app/common/components/floating-assistant-chat/assistant-settings/assistant-settings.component";
import { ChatInputComponent } from "src/app/common/components/floating-assistant-chat/chat-input/chat-input.component";
import { ChatLineComponent } from "src/app/common/components/floating-assistant-chat/chat-line/chat-line.component";
import { FloatingAssistantChatComponent } from "src/app/common/components/floating-assistant-chat/floating-assistant-chatcomponent";
import { MoveDialogComponent } from "src/app/common/components/floating-assistant-chat/move-dialog/move-dialog.component";
import { PromptEditorComponent } from "src/app/common/components/floating-assistant-chat/prompt-editor/prompt-editor.component";
import { PromptNodeEditorComponent } from "src/app/common/components/floating-assistant-chat/prompt-node-editor/prompt-node-editor.component";
import { PromptSelectorComponent } from "src/app/common/components/floating-assistant-chat/prompt-selector/prompt-selector.component";
import { ArticleLengthChartComponent } from "src/app/common/components/graphs/article-length-chart/article-length-chart.component";
import { CountChartComponent } from "src/app/common/components/graphs/count-chart/count-chart.component";
import { EngagementComponent } from "src/app/common/components/graphs/engagement/engagement.component";
import { EntitiesCountComponent } from "src/app/common/components/graphs/entities-count/entities-count.component";
import { IptcCountComponent } from "src/app/common/components/graphs/iptc-count/iptc-count.component";
import { UserNeedsCountComponent } from "src/app/common/components/graphs/user-needs-count/user-needs-count.component";
import { KpiPageComponent } from "src/app/common/components/kpi-page/kpi-page.component";
import { RequestStatusComponent } from "src/app/common/components/request-status/request-status.component";
import { SchedulingSelectorComponent } from "src/app/common/components/scheduling-selector/scheduling-selector.component";
import { SendAssistantComponent } from "src/app/common/components/send-assistant/send-assistant.component";
import { SummaryComponent } from "src/app/common/components/summary-tabs/summary/summary.component";
import { SummaryTabsComponent } from "src/app/common/components/summary-tabs/summary-tabs.component";
import { FooterTaggingComponent } from "src/app/common/components/tagging/footer-tagging/footer-tagging.component";
import { HeaderTaggingComponent } from "src/app/common/components/tagging/header-tagging/header-tagging.component";
import { PopupLabelComponent } from "src/app/common/components/tagging/popup-label/popup-label.component";
import { TagsComponent } from "src/app/common/components/tagging/tags/tags.component";
import { TagsListComponent } from "src/app/common/components/tagging/tags-list/tags-list.component";
import { TagsSelectComponent } from "src/app/common/components/tagging/tags-select/tags-select.component";
import { UserSelectComponent } from "src/app/common/components/user-select/user-select.component";
import { VideoAndTextComponent } from "src/app/common/components/video-and-text/video-and-text.component";
import { UserNeedIconPipe, UserNeedLabelPipe } from "src/app/common/pipes/article-to-userneed-pipe";
import { MediaToIcon } from "src/app/common/pipes/media-name-to-icon";
import { MillisToDurationPipe } from "src/app/common/pipes/millis-to-duration-pipe";
import { SanitizedHtmlPipe } from "src/app/common/pipes/sanitized-html-pipe";
import { SearchTypeToLabelPipe } from "src/app/common/pipes/search-type-to-label-pipe";
import { SentimentToIcon } from "src/app/common/pipes/sentiment-to-icon";
import { TranslateType } from "src/app/common/pipes/translate-type-pipe";
import { TypeToEmoticon } from "src/app/common/pipes/type-to-emoticon-pipe";

@NgModule({
  declarations: [
    ArticleLengthChartComponent,
    AssistantChatComponent,
    AssistantSettingsComponent,
    ChatInputComponent,
    ChatLineComponent,
    CountChartComponent,
    DropListComponent,
    EngagementComponent,
    EntitiesCountComponent,
    FeatureTourButtonComponent,
    FiltersComponent,
    FloatingAssistantChatComponent,
    FooterTaggingComponent,
    HeaderTaggingComponent,
    IptcCountComponent,
    KpiPageComponent,
    MediaToIcon,
    MillisToDurationPipe,
    MoveDialogComponent,
    PopupLabelComponent,
    PromptEditorComponent,
    PromptNodeEditorComponent,
    PromptSelectorComponent,
    RequestStatusComponent,
    SanitizedHtmlPipe,
    SchedulingSelectorComponent,
    SendAssistantComponent,
    SentimentToIcon,
    SpeakerComponent,
    SpeechSegmentComponent,
    SummaryComponent,
    SummaryTabsComponent,
    TagsComponent,
    TagsListComponent,
    TagsSelectComponent,
    TranslateType,
    TypeToEmoticon,
    UserNeedIconPipe,
    UserNeedLabelPipe,
    UserNeedsCompactComponent,
    UserNeedsCountComponent,
    UserNeedsTabComponent,
    UserSelectComponent,
    VideoAndTextComponent,
  ],
  exports: [
    ArticleLengthChartComponent,
    AssistantChatComponent,
    AssistantSettingsComponent,
    ButtonModule,
    CalendarModule,
    CardModule,
    ChartModule,
    ChatInputComponent,
    ChatLineComponent,
    ChipModule,
    ClipboardModule,
    CommonModule,
    ConfirmDialogModule,
    ConfirmPopupModule,
    ContextMenuModule,
    CountChartComponent,
    DialogModule,
    DividerModule,
    DragDropModule,
    DropListComponent,
    EngagementComponent,
    EntitiesCountComponent,
    FeatureTourButtonComponent,
    FiltersComponent,
    FloatingAssistantChatComponent,
    FloatLabelModule,
    FormsModule,
    ImageModule,
    InputSwitchModule,
    InputTextareaModule,
    InputTextModule,
    IptcCountComponent,
    KpiPageComponent,
    MarkdownModule,
    MediaToIcon,
    MenuModule,
    MessagesModule,
    MillisToDurationPipe,
    MoveDialogComponent,
    MultiSelectModule,
    NgAsModule,
    NgLetDirective,
    OverlayPanelModule,
    PaginatorModule,
    PanelModule,
    PopupLabelComponent,
    ProgressBarModule,
    ProgressSpinnerModule,
    PromptSelectorComponent,
    ReactiveFormsModule,
    RequestStatusComponent,
    SanitizedHtmlPipe,
    SchedulingSelectorComponent,
    ScrollPanelModule,
    SendAssistantComponent,
    SentimentToIcon,
    SkeletonModule,
    SliderModule,
    SpeakerComponent,
    SpeechSegmentComponent,
    SummaryTabsComponent,
    TableModule,
    TabViewModule,
    TagsComponent,
    TagsSelectComponent,
    ToastModule,
    ToggleButtonModule,
    TooltipModule,
    TranslateType,
    TreeSelectModule,
    TypeToEmoticon,
    UserNeedIconPipe,
    UserNeedLabelPipe,
    UserNeedsCompactComponent,
    UserNeedsCountComponent,
    UserNeedsTabComponent,
    UserSelectComponent,
  ],
  imports: [
    AccordionModule,
    AddContextMenuComponent,
    AddFilesPopupComponent,
    AutoCompleteModule,
    BaseChartDirective,
    ButtonModule,
    CalendarModule,
    CardModule,
    ChartModule,
    CheckboxModule,
    ChipModule,
    ClipboardModule,
    CommonModule,
    ConfirmDialogModule,
    ConfirmPopupModule,
    ContextMenuModule,
    DialogModule,
    DividerModule,
    DragDropModule,
    EditorModule,
    ExtensibleTextareaComponent,
    FileUploadModule,
    FloatLabelModule,
    FormsModule,
    ImageModule,
    InputSwitchModule,
    InputTextareaModule,
    InputTextModule,
    MarkdownModule,
    MenuModule,
    MessagesModule,
    MultiSelectModule,
    NgAsModule,
    NgLetDirective,
    OverlayPanelModule,
    PaginatorModule,
    PanelModule,
    ProgressBarModule,
    ProgressSpinnerModule,
    ReactiveFormsModule,
    RippleModule,
    ScrollPanelModule,
    SearchTypeToLabelPipe,
    SelectButtonModule,
    SkeletonModule,
    SliderModule,
    TableModule,
    TabViewModule,
    TieredMenuModule,
    ToggleButtonModule,
    TooltipModule,
    TreeSelectModule,
  ],
  providers: [ConfirmationService, DialogService, MessageService],
})
export class AppCommonModule {}
